import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";


// ============================
// 🧠 Get Organization AI Instructions
// ============================
export const getOrgAIInstructions = async (organization_id: string) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/ai-instructions/`;
    const response = await axios.get(endpoint, { headers });

    if (response.status >= 200 && response.status <= 400) {
      return { success: true, data: response.data };
    } else {
      console.error("Failed to fetch AI instructions:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error("Error fetching AI instructions:", error);
    return { success: false, data: error };
  }
};

// ============================
// ➕ Create AI Instruction
// ============================
export const createOrgAIInstruction = async (
  organization_id: string,
  instructionData: any
) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/ai-instructions/`;
    const response = await axios.post(endpoint, instructionData, { headers });

    if (response.status >= 200 && response.status <= 400) {
      return { success: true, data: response.data };
    } else {
      console.error("Failed to create AI instruction:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error("Error creating AI instruction:", error);
    return { success: false, data: error };
  }
};

// ============================
// ✏️ Update AI Instruction (PATCH)
// ============================
export const updateOrgAIInstruction = async (
  organization_id: string,
  instruction_id: number,
  updatedData: any
) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/ai-instructions/${instruction_id}/`;
    const response = await axios.patch(endpoint, updatedData, { headers });

    if (response.status >= 200 && response.status <= 400) {
      return { success: true, data: response.data };
    } else {
      console.error("Failed to update AI instruction:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error("Error updating AI instruction:", error);
    return { success: false, data: error };
  }
};

// ============================
// ❌ Delete AI Instruction
// ============================
export const deleteOrgAIInstruction = async (
  organization_id: string,
  instruction_id: number
) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/ai-instructions/${instruction_id}/`;
    const response = await axios.delete(endpoint, { headers });

    if (response.status >= 200 && response.status <= 400) {
      return { success: true, data: response.data };
    } else {
      console.error("Failed to delete AI instruction:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error("Error deleting AI instruction:", error);
    return { success: false, data: error };
  }
};
